import JWT from 'jsonwebtoken';

export const decodeAndFormatJWT = jwt => {
  const { user, pending } = JWT.decode(jwt);
  return { user, pendencies: pending };
};
